import { ElectricBolt } from "@mui/icons-material";
import { Avatar, Divider } from "@mui/material";
import { red, teal } from "@mui/material/colors";
import React, { useEffect } from "react";
import { Order, OrderItemType, OrderStatus } from "../../../types/orderTypes";
import { formatDate } from "../../../utils/formatDate";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import {
  fetchProductById,
  fetchProductDetailById,
} from "../../../State/customer/ProductSlice";

interface OrderItemProp {
  item: OrderItemType;
  order: Order;
}

export const OrderItem: React.FC<OrderItemProp> = ({ item, order }) => {
  const formattedDate = formatDate(order.deliverDate);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // read normalized stores
  const productsById = useAppSelector((s) => s.product.entities);
  const detailsById = useAppSelector((s) => s.product.entitiesDetails);

  // fetch all unique product & detail ids for this order (no "current")
  useEffect(() => {
    const productIds = Array.from(
      new Set(order.items.map((i) => i.productId).filter(Boolean))
    );
    productIds.forEach((id) => dispatch(fetchProductById(id)));

    const detailIds = Array.from(
      new Set(order.items.map((i) => i.productDetailId).filter(Boolean))
    );
    detailIds.forEach((id) => dispatch(fetchProductDetailById(id)));
  }, [dispatch, order.items]); // include dispatch to satisfy lint rule

  // data for THIS row
  const prod = productsById[item.productId!];
  const detail = detailsById[item.productDetailId!];

  return (
    <>
      <div
        onClick={() => navigate(`/account/order/${order.id}/${item.id}`)}
        className="text-sm pb-5 pl-5 pr-5 space-y-3 rounded-md cursor-pointer"
      >
        {order.items.indexOf(item) === 0 && (
          <div>
            <h1 className="font-bold text-lg">Order {order.id}</h1>
            <Divider />
          </div>
        )}

        <div className="flex items-center gap-5">
          <div>
            {order.orderStatus === OrderStatus.CANCELLED ? (
              <Avatar sizes="small" sx={{ bgcolor: red[500] }}>
                <ElectricBolt />
              </Avatar>
            ) : (
              <Avatar sizes="small" sx={{ bgcolor: teal[500] }}>
                <ElectricBolt />
              </Avatar>
            )}
          </div>
          <div>
            <h1 className="font-bold text-primary">{order.orderStatus}</h1>
            <p>Arrived by {formattedDate}</p>
          </div>
        </div>

        <div className="p-5 bg-teal-50 flex gap-3">
          <div className="w-[240px]">
              {prod?.images&&(<img src={prod.images[0]} className="" alt="Not found" />)}
            </div>
          <div className="w-full space-y-2 ">

            <h1>Product Details:</h1>
            <div>
           {prod?.sellerName&&( <h1><strong>Store: </strong> {prod?.sellerName??"Loading"}</h1>)}  
            <h1 ><strong>Name:</strong> {prod?.title ?? "Loading..."}</h1>

              <p>
                <strong>size: </strong>
                {detail?.size ?? "N/A"}
              </p>
              <p>
                <strong>color: </strong>
                {detail?.color ?? "N/A"}
              </p>
              <p>
                <strong>quantity: </strong>
                {item.quantity}
              </p>
              
            </div>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};
